/* eslint-disable react/no-unused-prop-types */
import Accordion from '@/stories/components/Common/FormComponents/Accordion'
import Dropdown from '@/stories/components/Common/FormComponents/Dropdown'

export interface SortingProps {
  sortList?: {
    name: string
    key: string
    orderList?: { value }[]
  }[]
  onSortUpdate: (payload) => void
  forMobile?: boolean
  onClose?: () => void
}
const SortingOptions = ({
  sortList,
  onSortUpdate = () => null,
}: SortingProps) => {
  return (
    <div className="">
      {sortList?.map(({ name, key, orderList }, index) => (
        <div className="md:w-100% my-3" key={`sort${index}`}>
          <Dropdown
            defaultOptionText={name}
            options={orderList?.map(({ value }) => value)}
            label=""
            onChangeSelection={payload =>
              onSortUpdate({ payload, orderList, type: key })
            }
          />
        </div>
      ))}
    </div>
  )
}
const DesktopSorting = (props: SortingProps) => {
  return (
    <div>
      <div className="text-sm">Sort By</div>
      <SortingOptions {...props} />
    </div>
  )
}

const MobileSorting = (props: SortingProps) => {
  return (
    <div>
      <div className="mb-2  mt-3 flex justify-between px-3">
        <div className="text-sm">Sort & Filter</div>
        <div
          className="text-brand-blue-azureRadiance text-xs"
          onClick={props.onClose}
        >
          Close
        </div>
      </div>
      <Accordion label="Sort by">
        <SortingOptions {...props} />
      </Accordion>
    </div>
  )
}

const Sorting = (props: SortingProps) => {
  if (props.forMobile) return <MobileSorting {...props} />
  return <DesktopSorting {...props} />
}

export default Sorting
